export default __webpack_public_path__ + "static/media/Arrow.ab05f5f4.svg";